import {email, required, confirmation, acceptance, length, numericality} from "redux-form-validators";

export const validations = {

    //Login form validation rules
    loginForm: {
        email: [
            required({
                msg: "Email-ul este obligatoriu"
            }),
            email({
                message: "Email-ul nu este valid"
            })
        ],
        password: [
            required({
                msg: "Parola este obligatorie"
            })
        ]
    },
    registerForm: {
        firstName: [
            required({
                msg: "Prenumele este obligatoriu"
            })
        ],
        lastName: [
            required({
                msg: "Numele este obligatoriu"
            })
        ],
        userName: [
            required({
                msg: "Numele de utilizator este obligatoriu"
            })
        ],
/*
        city: [
            required({
                msg: "Orasul este obligatoriu"
            })
        ],
        county: [
            required({
                msg: "Judetul este obligatoriu"
            })
        ],
*/
        email: [
            required({
                msg: "Email-ul este obligatoriu"
            }),
            email({
                message: "Email-ul nu este valid"
            })
        ],
        password: [
            required({ msg: "Parola este obligatorie"}),
            length({ minimum: 6, msg: "Parola trebuie să conțină cel puțin 6 caractere" })
        ],
        passwordConfirm: [
            required({
                msg: "Confirmarea parolei este obligatorie"
            }), 
            confirmation({
                field: 'password',
                msg: "Parolele nu coincid"
            })
        ],
        agreement: [
            acceptance({
                accept: true,
                msg: 'Trebuie să fii de acord cu termenii și condițiile',
            })
        ]
        /*month: [
            numericality({
                otherThan: 0,
                msg: 'Te rugam sa selectezi luna',
            })
        ],
        day: [
            numericality({
                otherThan: 0,
                msg: 'Te rugam sa selectezi ziua',
            })
        ],
        year: [
            numericality({
                otherThan: 0,
                msg: 'Te rugam sa selectezi anul',
            })
        ],*/
    },

    forgotPasswordForm : {
        email: [
            required({
                msg: "Email-ul este obligatoriu"
            }),
            email({
                message: "Email-ul nu este valid"
            })
        ], 
    },

    resetPasswordForm : {
        email: [
            required({
                msg: "Email-ul este obligatoriu"
            }),
            email({
                message: "Email-ul nu este valid"
            })
        ],

        tempPassword: [
            required({
                msg: "Parola temporară este obligatorie"
            })
        ],
        
        password: [
            required({
                msg: "Parola este obligatorie"
            }),
            length({ minimum: 6, msg: "Parola trebuie sa conțină cel puțin 6 caractere" })
        ],
        passwordConfirm: [
            confirmation({
                field: 'password',
                msg: "Parolele nu coincid"
            })
        ],
    },

    /*addCommentForm: {
        comment: [
            required({
                msg: "Adaugati un comentariu"
            })
        ]
    }*/

    changePasswordForm : {
        oldPassword: [
            required({
                msg: "Parola veche este obligatorie"
            })
        ],
        
        password: [
            required({
                msg: "Parola nouă este obligatorie"
            }),
            length({ minimum: 6, msg: "Parola trebuie sa conțină cel puțin 6 caractere" })
        ],
        passwordConfirm: [
            confirmation({
                field: 'password',
                msg: "Parola nu coincide cu noua parolă"
            })
        ],
    },

    paymentForm : {
        first_name: [
            required({
                msg: "Prenumele este obligatoriu"
            })
        ],
        last_name: [
            required({
                msg: "Numele este obligatoriu"
            })
        ],
        address: [
            required({
                msg: "Adresa este obligatorie"
            })
        ],
        email: [
            required({
                msg: "Email-ul este obligatoriu"
            }),
            email({
                message: "Email-ul nu este valid"
            })
        ],
        phone: [
            required({
                msg: "Telefonul mobil este obligatoriu"
            })
        ],
    },

    contactForm: {
        name: [
            required({
                msg: "Numele este obligatoriu"
            })
        ],
        email: [
            required({
                msg: "Email-ul este obligatoriu"
            }),
            email({
                message: "Email-ul nu este valid"
            })
        ],
        subject: [
            required({
                msg: "Subiectul este obligatoriu"
            })
        ],
        message: [
            required({
                msg: "Mesajul este obligatoriu"
            })
        ],
    }
};




// WEBPACK FOOTER //
// ./src/SHARED/config/siteValidations.js